import axios from '@api/axios';
import addressesService from '@api/addresses';

const axiosInstance = axios.create({
    baseURL: `/api/clients`
});

const index = function() {
    return axiosInstance.get('');
};

const set = function(id) {
    return axiosInstance.put(`set-client/${id}`);
};

const edit = function(form) {
    return axiosInstance.post('', form);
};

const client = window.app.client;

const toVue = function() {
    let clientAddress = addressesService.defaultInput();

    if (client.address) {
        clientAddress.line1 = client?.address?.line_1 || '';
        clientAddress.line2 = client?.address?.line_2 || '';
        clientAddress.postalCode = client?.address?.postal_code || '';
        clientAddress.latitude = client?.address?.latitude || '';
        clientAddress.longitude = client?.address?.longitude || '';
        clientAddress.city = client?.address?.city || '';
        clientAddress.county = client?.address?.county_id || '';
    }

    return {
        id: client?.id,
        name: client?.name || '',
        email: client?.email || '',
        phoneNumber: client?.phone_number,

        address: clientAddress
    };
};

function emptyOrNull(field) {
    return !field || field == '';
};

const enquiryReady = function() {
    const address = client?.address;

    return (
        emptyOrNull(address) ||
        emptyOrNull(address.postal_code) ||
        emptyOrNull(address.postal_code) ||
        emptyOrNull(address.latitude) ||
        emptyOrNull(address.line_1) ||
        emptyOrNull(client?.phone_number)
    );
};
export default { axios: axiosInstance, index, set, edit, toVue, enquiryReady, client };
